import { MaybeSort } from "Shared/types/Sort";
import React, { FC } from "react";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";

interface SortIconProps {
  id: string;
  className: string;
  thisColSort: MaybeSort;
}

const SortIcon: FC<SortIconProps> = ({ id, thisColSort, className }) => {
  if (thisColSort === "asc") {
    return (
      <ArrowUpward className={className} id={`${id}-asc`} color="inherit" />
    );
  } else if (thisColSort === "desc") {
    return (
      <ArrowDownward className={className} id={`${id}-desc`} color="inherit" />
    );
  } else {
    return (
      <ArrowUpward
        className={`${className} .iconHover`}
        id={`${id}-desc`}
        color="inherit"
      />
    );
  }
};
export default SortIcon;
